import { Link } from "react-router-dom";
import { Clock, Phone } from "lucide-react";
import { formatTime, telHref } from "@/lib/api";
import { longDate } from "@/lib/dates";

export const APPT_STATUSES = ["Scheduled", "In Shop", "Ready for Pickup", "Completed", "Cancelled"];

const STATUS_CLS = {
  Scheduled: "bg-[#FFD23F] text-[#121214]",
  "In Shop": "bg-[#3b82f6]/20 text-[#93c5fd] border border-[#3b82f6]/40",
  "Ready for Pickup": "bg-[#7ee08a]/15 text-[#b9f5c0] border border-[#7ee08a]/40",
  Completed: "bg-zinc-700 text-zinc-200",
  Cancelled: "bg-[#C8322B]/20 text-[#ff8a80] line-through",
};

export const ApptStatus = ({ status }) => (
  <span className={`inline-flex rounded-sm px-2 py-0.5 text-xs font-semibold uppercase tracking-wide ${STATUS_CLS[status]}`} data-testid="appointment-status-badge">{status}</span>
);

export const AppointmentCard = ({ a, showDate = true }) => (
  <div className="rounded-lg border border-zinc-800 bg-[#121214] p-3" data-testid={`appointment-card-${a.id}`}>
    <div className="flex items-start justify-between gap-2">
      <Link to={`/admin/appointments/${a.id}`} className="min-w-0 flex-1" data-testid="appointment-open-link">
        <p className="break-words font-semibold text-zinc-100" data-testid="appointment-card-title">{a.name}{a.vehicle && ` · ${a.vehicle}`}</p>
        {a.job && <p className="break-words text-sm text-zinc-400">{a.job}</p>}
        <p className="mt-1 flex items-center gap-1.5 text-sm text-zinc-300" data-testid="appointment-card-when">
          <Clock className="h-3.5 w-3.5" />
          {showDate && longDate(a.dropoff_date)}{showDate && a.dropoff_time && " · "}{a.dropoff_time && formatTime(a.dropoff_time)}
          {!showDate && !a.dropoff_time && "Any time"}
        </p>
      </Link>
      <ApptStatus status={a.status} />
    </div>
    <a href={telHref(a.phone)} className="mt-2 inline-flex h-11 items-center gap-2 rounded-md border border-zinc-700 px-3 text-sm text-[#FFD23F] hover:bg-zinc-800" data-testid="appointment-phone-link">
      <Phone className="h-4 w-4" /> {a.phone}
    </a>
  </div>
);
